<div mat-dialog-title>
    <h1 style="display: flex;align-items: center;margin:0;padding: 5px 0 0 0;font-size:22px;font-weight:bold;">
        Customer Priorities
    </h1>
    <app-dialog-close-button layoutMode="float" data-testid="customer-priorities-close-btn" (click)="close()"></app-dialog-close-button>
</div>
<hr>
<p>Arrange up to four key vehicle features based on customer importance.</p>
<section class="wants">
    <div class="cna-list-container">
        <h2>Available Priorities</h2>
        <div
                id="sourceList"
                #todoList="cdkDropList"
                cdkDropList
                [cdkDropListData]="cnaService.allOptions"
                [cdkDropListConnectedTo]="[doneList]"
                class="cna-item-list"
                (cdkDropListDropped)="drop($event)">
            <div class="cna-list-item" *ngFor="let item of cnaService.allOptions" cdkDrag>
                <img [src]='getOptionIcon(item)'><span>{{ item }}</span>
                <div *cdkDragPreview class="cna-list-item"
                     style="background: #fff!important;color:#000!important;padding:10px!important;"><img
                        [src]='getOptionIcon(item)' style="width:40px;height:40px"><span>{{ item }}</span></div>
            </div>
        </div>
    </div>
    <div class="cna-list-container">
        <h2>Selected Priorities</h2>
        <div
                id="targetList"
                #doneList="cdkDropList"
                cdkDropList
                [cdkDropListData]="cnaService.selectedOptions"
                [cdkDropListConnectedTo]="[todoList]"
                class="cna-item-list"
                (cdkDropListDropped)="drop($event)">
            <div class="cna-list-item" *ngFor="let item of cnaService.selectedOptions" cdkDrag>
                <img [src]='getOptionIcon(item)'><span>{{ item }}</span>
                <div *cdkDragPreview class="cna-list-item"
                     style="background: #fff!important;color:#000!important;padding:10px!important;"><img
                        [src]='getOptionIcon(item)' style="width:40px;height:40px"><span>{{ item }}</span></div>
            </div>
        </div>
    </div>
</section>
